import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgHandset = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 22" {...props}>
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M18.614.505c.756.674 1.23 1.099 1.424 1.274 1.076.957 1.25 2.312.52 4.063-1.091 2.628-5.188 8.963-14.11 14.318-1.97 1.385-3.738 1.073-4.55 0-.541-.715-1.072-1.4-1.592-2.055-.578-.892-.335-1.72.73-2.484 1.595-1.145 1.085-.741 2.39-1.635 1.303-.894 1.292-.694 3.022 0 1.729.694 1.746 1.3 3.459-.337 1.142-1.09 2.606-2.58 4.391-4.47.67-.629.67-1.414 0-2.355-1.004-1.41-1.004-1.953 0-3.499a29.29 29.29 0 0 1 2.068-2.82c.744-.673 1.493-.673 2.25 0z"
    />
  </svg>
);
const Memo = memo(SvgHandset);
export default Memo;
